import { DataModel } from "common/models/utility-models/base-model";

export class consentModel extends DataModel
{
  override id: "";

}